import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
        alta:
          "border-transparent bg-destructive/12 text-destructive font-semibold",
        media:
          "border-transparent bg-warning/12 text-warning-foreground font-semibold",
        bassa:
          "border-transparent bg-success/12 text-success font-semibold",
        chip:
          "border-transparent bg-chip text-chip-foreground font-medium",
        success:
          "border-transparent bg-success/12 text-success",
        info:
          "border-transparent bg-info/12 text-info",
        warning:
          "border-transparent bg-warning/12 text-warning-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
